export const SELECT_FIELD_CONST = {
  VARIANT: {
    FILLED: 'filled',
    OUTLINED: 'outlined',
    STANDARD: 'standard',
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomSingleSelect/Constants.js